import React from 'react';
import { useTranslation } from "react-i18next";

function TimezoneSelectNoGuess({timeZone, setTimeZone}) {
  const { t } = useTranslation();

  // IANA timezone identifiers - organized by region for better UX
  const timezones = [
    // Americas
    { value: "America/New_York", label: "America/New_York (Eastern Time)" },
    { value: "America/Chicago", label: "America/Chicago (Central Time)" },
    { value: "America/Denver", label: "America/Denver (Mountain Time)" },
    { value: "America/Los_Angeles", label: "America/Los_Angeles (Pacific Time)" },
    { value: "America/Anchorage", label: "America/Anchorage (Alaska)" },
    { value: "Pacific/Honolulu", label: "Pacific/Honolulu (Hawaii)" },
    { value: "America/Phoenix", label: "America/Phoenix (Arizona)" },
    { value: "America/Toronto", label: "America/Toronto" },
    { value: "America/Vancouver", label: "America/Vancouver" },
    { value: "America/Mexico_City", label: "America/Mexico_City" },
    { value: "America/Sao_Paulo", label: "America/Sao_Paulo" },
    { value: "America/Buenos_Aires", label: "America/Buenos_Aires" },
    { value: "America/Lima", label: "America/Lima" },
    { value: "America/Bogota", label: "America/Bogota" },
    { value: "America/Caracas", label: "America/Caracas" },
    { value: "America/Santiago", label: "America/Santiago" },

    // Europe
    { value: "Europe/London", label: "Europe/London" },
    { value: "Europe/Paris", label: "Europe/Paris" },
    { value: "Europe/Berlin", label: "Europe/Berlin" },
    { value: "Europe/Rome", label: "Europe/Rome" },
    { value: "Europe/Madrid", label: "Europe/Madrid" },
    { value: "Europe/Amsterdam", label: "Europe/Amsterdam" },
    { value: "Europe/Brussels", label: "Europe/Brussels" },
    { value: "Europe/Vienna", label: "Europe/Vienna" },
    { value: "Europe/Warsaw", label: "Europe/Warsaw" },
    { value: "Europe/Prague", label: "Europe/Prague" },
    { value: "Europe/Budapest", label: "Europe/Budapest" },
    { value: "Europe/Athens", label: "Europe/Athens" },
    { value: "Europe/Stockholm", label: "Europe/Stockholm" },
    { value: "Europe/Copenhagen", label: "Europe/Copenhagen" },
    { value: "Europe/Oslo", label: "Europe/Oslo" },
    { value: "Europe/Helsinki", label: "Europe/Helsinki" },
    { value: "Europe/Dublin", label: "Europe/Dublin" },
    { value: "Europe/Lisbon", label: "Europe/Lisbon" },
    { value: "Europe/Moscow", label: "Europe/Moscow" },
    { value: "Europe/Istanbul", label: "Europe/Istanbul" },
    { value: "Europe/Zurich", label: "Europe/Zurich" },

    // Asia
    { value: "Asia/Shanghai", label: "Asia/Shanghai (China)" },
    { value: "Asia/Hong_Kong", label: "Asia/Hong_Kong" },
    { value: "Asia/Taipei", label: "Asia/Taipei (Taiwan)" },
    { value: "Asia/Tokyo", label: "Asia/Tokyo (Japan)" },
    { value: "Asia/Seoul", label: "Asia/Seoul (South Korea)" },
    { value: "Asia/Singapore", label: "Asia/Singapore" },
    { value: "Asia/Bangkok", label: "Asia/Bangkok (Thailand)" },
    { value: "Asia/Jakarta", label: "Asia/Jakarta (Indonesia)" },
    { value: "Asia/Manila", label: "Asia/Manila (Philippines)" },
    { value: "Asia/Kuala_Lumpur", label: "Asia/Kuala_Lumpur (Malaysia)" },
    { value: "Asia/Kolkata", label: "Asia/Kolkata (India)" },
    { value: "Asia/Dubai", label: "Asia/Dubai (UAE)" },
    { value: "Asia/Karachi", label: "Asia/Karachi (Pakistan)" },
    { value: "Asia/Dhaka", label: "Asia/Dhaka (Bangladesh)" },
    { value: "Asia/Kathmandu", label: "Asia/Kathmandu (Nepal)" },
    { value: "Asia/Colombo", label: "Asia/Colombo (Sri Lanka)" },
    { value: "Asia/Yangon", label: "Asia/Yangon (Myanmar)" },
    { value: "Asia/Ho_Chi_Minh", label: "Asia/Ho_Chi_Minh (Vietnam)" },
    { value: "Asia/Phnom_Penh", label: "Asia/Phnom_Penh (Cambodia)" },
    { value: "Asia/Vientiane", label: "Asia/Vientiane (Laos)" },
    { value: "Asia/Jerusalem", label: "Asia/Jerusalem (Israel)" },
    { value: "Asia/Riyadh", label: "Asia/Riyadh (Saudi Arabia)" },
    { value: "Asia/Tehran", label: "Asia/Tehran (Iran)" },
    { value: "Asia/Baghdad", label: "Asia/Baghdad (Iraq)" },
    { value: "Asia/Kabul", label: "Asia/Kabul (Afghanistan)" },
    { value: "Asia/Tashkent", label: "Asia/Tashkent (Uzbekistan)" },

    // Pacific
    { value: "Australia/Sydney", label: "Australia/Sydney" },
    { value: "Australia/Melbourne", label: "Australia/Melbourne" },
    { value: "Australia/Brisbane", label: "Australia/Brisbane" },
    { value: "Australia/Perth", label: "Australia/Perth" },
    { value: "Australia/Adelaide", label: "Australia/Adelaide" },
    { value: "Pacific/Auckland", label: "Pacific/Auckland (New Zealand)" },
    { value: "Pacific/Fiji", label: "Pacific/Fiji" },
    { value: "Pacific/Guam", label: "Pacific/Guam" },
    { value: "Pacific/Port_Moresby", label: "Pacific/Port_Moresby (Papua New Guinea)" },

    // Africa
    { value: "Africa/Cairo", label: "Africa/Cairo (Egypt)" },
    { value: "Africa/Johannesburg", label: "Africa/Johannesburg (South Africa)" },
    { value: "Africa/Lagos", label: "Africa/Lagos (Nigeria)" },
    { value: "Africa/Nairobi", label: "Africa/Nairobi (Kenya)" },
    { value: "Africa/Casablanca", label: "Africa/Casablanca (Morocco)" },
    { value: "Africa/Algiers", label: "Africa/Algiers (Algeria)" },
    { value: "Africa/Tunis", label: "Africa/Tunis (Tunisia)" },
    { value: "Africa/Accra", label: "Africa/Accra (Ghana)" },

    // Atlantic
    { value: "Atlantic/Reykjavik", label: "Atlantic/Reykjavik (Iceland)" },
    { value: "Atlantic/Azores", label: "Atlantic/Azores" },
    { value: "Atlantic/Bermuda", label: "Atlantic/Bermuda" },
  ];

  return (
  <>
      <select
        type="select"
        className="bg-[#EEF2FF] rounded-3xl text-sm sm:text-lg sm:leading-5 p-3 text-[#000000] w-full"
        label="select timezone"
        value={timeZone}
        onChange={(e) => setTimeZone(e.target.value)}
      >
          <option value="" className="text-gray-500">{t("register.select_timezone")}</option>
          {timezones.map((timezone) => (
            <option key={timezone.value} value={timezone.value}>
              {timezone.label}
            </option>
      ))}
      </select>
  </>
  );
};

export default TimezoneSelectNoGuess;